<template>
	<div class="settingsGroupTitle settingsGroupHeader">
		<div class="settingsGroupHeader__row">
			<i
				:class="resolvedIconClass"
				class="settingsGroupHeader__icon"
			/>
			<span>{{ title }}</span>
			<div
				class="settingsGroupHeader__actions"
				v-if="$slots.default"
			>
				<slot />
			</div>
		</div>
		<div
			class="settingsGroupHeader__caption"
			v-if="caption"
		>
			{{ caption }}
		</div>
	</div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

import { useIconClass } from 'src/composables/useIconClass';

export default defineComponent({
	name: 'SettingsGroupHeader',
	props: {
		caption: { default: null, type: String },
		icon: { required: true, type: String },
		title: { required: true, type: String },
	},
	setup(props) {
		const { iconClass } = useIconClass();

		const resolvedIconClass = computed((): string => iconClass(props.icon));

		return { resolvedIconClass };
	},
});
</script>

<style lang="scss" scoped>
.settingsGroupHeader {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

/* Konstante Zeilenhöhe in Small-Button-Größe: Header mit und ohne
   Aktions-Button sind gleich hoch - die Seiten springen beim Wechsel nicht. */
.settingsGroupHeader__row {
	align-items: center;
	display: flex;
	gap: 10px;
	min-height: 2.25rem;
}

.settingsGroupHeader__icon {
	color: var(--app-primary);
	font-size: var(--text-lg);
	width: 1.3em;
}

/* Aktionen erben sonst die Versal-Optik des Titels; bei langen Titeln
   bricht der Titel um, nie der Button. */
.settingsGroupHeader__actions {
	flex-shrink: 0;
	font-weight: 400;
	letter-spacing: normal;
	margin-left: auto;
	text-transform: none;
}

/* Untertitel läuft im Fließtext-Ton - nicht in der Versal-Optik des Titels. */
.settingsGroupHeader__caption {
	color: var(--settings-muted);
	font-size: var(--text-sm);
	font-weight: 400;
	letter-spacing: normal;
	line-height: var(--leading-normal);
	text-transform: none;
}
</style>
